// extracted by mini-css-extract-plugin
module.exports = {"dialCode":"Generator_dialCode__WNfm2","preview":"Generator_preview__2hcau","code":"Generator_code__rP7Jp"};